import {
  TransactionItemDrawerMode,
  TransactionItemDrawerModeEnum,
} from '@/features/transaction_items/List/type';
import { useTranslation } from '@/i18n';
import { ButtonGroup, ButtonV2 } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useMemo } from 'react';
import styles from './Header.module.scss';

export type Props = {
  mode: TransactionItemDrawerMode;
  onSetMode: (mode: TransactionItemDrawerMode) => void;
  isLoading: boolean;
  onDeleteClick: () => void;
};

const cx = classNames.bind(styles);

export const TransactionItemHeader: FC<Props> = memo(
  ({ mode, onSetMode, isLoading, onDeleteClick }) => {
    const { t } = useTranslation();
    const title = useMemo(() => {
      return (
        <div className={cx(styles['title'])}>
          {t(`transaction_items.drawer.${mode}.title`)}
          {mode === TransactionItemDrawerModeEnum.DETAIL && (
            <ButtonGroup direction='horizontal'>
              <ButtonV2
                isSecondary
                color='danger'
                isDisabled={isLoading}
                onClick={onDeleteClick}
              >
                {t('delete')}
              </ButtonV2>
              <ButtonV2
                onClick={() => onSetMode(TransactionItemDrawerModeEnum.EDIT)}
                isSecondary
                isDisabled={isLoading}
              >
                {t('edit')}
              </ButtonV2>
            </ButtonGroup>
          )}
        </div>
      );
    }, [t, mode, isLoading, onDeleteClick, onSetMode]);

    return title;
  }
);
TransactionItemHeader.displayName = 'TransactionItemHeader';
